import {
    createSlice,
    PayloadAction,
} from '@reduxjs/toolkit';

import {
    RealtimeChannelDTO,
    UserRealtimeChannelDTO,
} from '../../../types/realtime';
import { MyRealtimeChannelDTO } from '../../../types/realtime/MyRealtimeChannelDTO';

interface RealtimeState {

    // =====================================
    // Channels
    // =====================================

    channels: RealtimeChannelDTO[];

    selectedChannel:
    RealtimeChannelDTO | null;

    channelModalOpen: boolean;

    // =====================================
    // Current User
    // =====================================

    myChannels: MyRealtimeChannelDTO[];

    // =====================================
    // User Subscriptions
    // =====================================

    users: UserRealtimeChannelDTO[];

    selectedUser:
    UserRealtimeChannelDTO | null;

    userModalOpen: boolean;

    paginator: any;
    pageSize: number;

    loading: boolean;
}

const initialState: RealtimeState = {

    channels: [],

    selectedChannel: null,

    channelModalOpen: false,

    myChannels: [],

    users: [],

    selectedUser: null,

    userModalOpen: false,

    paginator: null,
    pageSize: 10,

    loading: false,
};

const realtimeSlice = createSlice({
    name: 'realtime',
    initialState,

    reducers: {

        // =====================================
        // CHANNELS
        // =====================================

        setChannels(
            state,
            action: PayloadAction<RealtimeChannelDTO[]>
        ) {
            state.channels =
                action.payload;
        },

        setSelectedChannel(
            state,
            action: PayloadAction<RealtimeChannelDTO | null>
        ) {
            state.selectedChannel =
                action.payload;
        },

        setChannelModalOpen(
            state,
            action: PayloadAction<boolean>
        ) {
            state.channelModalOpen =
                action.payload;
        },

        clearSelectedChannel(
            state
        ) {
            state.selectedChannel =
                null;
        },

        // =====================================
        // MY CHANNELS
        // =====================================

        setMyChannels(
            state,
            action: PayloadAction<MyRealtimeChannelDTO[]>
        ) {
            state.myChannels =
                action.payload;
        },

        // =====================================
        // USERS
        // =====================================

        setUsers(
            state,
            action: PayloadAction<any>
        ) {

            state.users =
                action.payload.content;

            state.paginator =
                action.payload;
        },

        // =====================================
        // PAGINATION
        // =====================================

        setPageSize(
            state,
            action: PayloadAction<number>
        ) {
            state.pageSize =
                action.payload;
        },

        setSelectedUser(
            state,
            action: PayloadAction<UserRealtimeChannelDTO | null>
        ) {
            state.selectedUser =
                action.payload;
        },

        setUserModalOpen(
            state,
            action: PayloadAction<boolean>
        ) {
            state.userModalOpen =
                action.payload;
        },

        clearSelectedUser(
            state
        ) {
            state.selectedUser =
                null;
        },

        // =====================================
        // LOADING
        // =====================================

        setLoading(
            state,
            action: PayloadAction<boolean>
        ) {
            state.loading =
                action.payload;
        },
    },
});

export const {

    // Channels
    setChannels,
    setSelectedChannel,
    setChannelModalOpen,
    clearSelectedChannel,

    // My channels
    setMyChannels,

    // Users
    setUsers,
    setPageSize,
    setSelectedUser,
    setUserModalOpen,
    clearSelectedUser,

    // Loading
    setLoading,

} = realtimeSlice.actions;

export default realtimeSlice.reducer;